/** Active suppliers shown on the Existing suppliers tab and used for ordering. */
export const countActiveVenueSuppliers = suppliers =>
  Array.isArray(suppliers)
    ? suppliers.filter(supplier => supplier?.isActive === true).length
    : 0
